import React from 'react'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { LocalGridFragment } from '../../../generated/graphql'
import { calculatorVar } from '../../../apollo/reactive-vars'
import { SystemContainerCharts } from '../../system-container/SystemContainerCharts'
import { EnergyType } from '../../../calculators/EnergyFlow'

type Props = {
  localGrid?: LocalGridFragment
  energyType: EnergyType
}

export function LocalGridEnergySystemCharts({
  localGrid,
  energyType,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const calculator = useReactiveVar(calculatorVar)

  const localGridCalculator = calculator?.findLocalGrid(localGrid?.id ?? '')
  if (!localGridCalculator) {
    return <></>
  }

  return (
    <SystemContainerCharts
      title={t(`localGrid.tabs.energySystem.chartsByEnergyType.${energyType}`)}
      chartTitlePrefix={t(
        `localGrid.tabs.energySystem.providedByEnergyType.${energyType}`,
      )}
      providers={localGridCalculator.getProviders()}
      energyTypes={[energyType]}
    />
  )
}
